module.exports = __webpack_public_path__ + "static/media/cardiograma.63b717ca.svg";